import script from "./SubscriptionListByProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionListByProduct.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionListByProduct.vue?vue&type=style&index=0&id=7fbf9948&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fbf9948"]])

export default __exports__